import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { tertiary600, gray200 } from 'components/new_ui/Colors';
import MemberIcon from 'components/Common/Members/Widgets/Icon/Index';

const dateFormat = (value) => {
  const date = new Date(value);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  return date.toLocaleDateString('en-US', options);
};

export default function Rating({ rating }) {
  const rate = useMemo(() => rating.attributes.rate * 20, []);

  const content = (
    <>
      <div className="d-lg-flex justify-content-between align-items-center mb-2">
        <div className="fw-semibold">
          {rating.attributes.member?.full_name || 'Member Unknown'}
        </div>

        <div
          className="dashboard-rating progress bg-white"
          style={{ height: '1.5rem', width: '7.5rem' }}
        >
          <div
            className="progress-bar w-100"
            role="progressbar"
            style={{ background: `linear-gradient(90deg, ${tertiary600} ${rate}%, ${gray200} 0%)` }}
            aria-label="Rating"
            aria-valuenow={rate}
            aria-valuemin="0"
            aria-valuemax="100"
          />
        </div>
      </div>

      <div className="fw-light">
        {rating.attributes.feedback.answer}
      </div>

      <small className="text-muted">
        {dateFormat(rating.attributes.created_at)}
      </small>
    </>
  );

  return (
    <MemberIcon
      member={rating.attributes.member}
      contentClassName="w-100"
      wrapperClassName="mb-5 align-items-start"
    >
      {content}
    </MemberIcon>
  );
}

Rating.propTypes = {
  rating: PropTypes.object.isRequired,
};
